module.exports = __webpack_public_path__ + "img/speaker_icon.903e62f2.svg";